// Webpack Imports
import AOS from "aos";
import * as bootstrap from "bootstrap";
import mariamarne from "./mariamarne";

(function ($) {
  "use strict";

  // Inicializaciones
  AOS.init();

  //Sombra menu al hacer scroll
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 0) {
      $("#header").addClass("is_sticky");
    } else {
      $("#header").removeClass("is_sticky");
    }
  });

  // - scroll de los anclas
  $("[data-mariamarne-scroll]").on("click", function (params) {
    mariamarne.animatedScroll($(this).attr("data-mariamarne-scroll"));
  });

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})(jQuery);

global.mariamarne = mariamarne;
